<template>
  <div id="app">
    <Brow />
    <keep-alive :exclude="['PhotoUploader']">
        <router-view :key="$route.path" />
    </keep-alive>
        

  </div>
</template>

<script>
import Brow from "@/components/Brow.vue";

export default {
  components: {
    Brow,
  },
};
</script>
<style scoped>
    #app{
        height: 100vh;
    }
</style>